import PropTypes from 'prop-types';
import React from 'react';
import { IoIosArrowRoundBack as ArrowLeftIcon } from 'react-icons/io';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  button: {
    '&:disabled': {
      opacity: 0.15,
    },
  },
  icon: {
    color: '#ffae49',
    fontSize: 22,
    verticalAlign: 'middle',
  },
});

const RideTooltipLeftArrowFooterComponent = React.memo(
  ({ backProps, index }) => {
    const classes = useStyles();
    return (
      <button
        className={classes.button}
        disabled={index === 0}
        type="button"
        {...backProps}>
        <ArrowLeftIcon className={classes.icon} />
      </button>
    );
  }
);

RideTooltipLeftArrowFooterComponent.propTypes = {
  backProps: PropTypes.shape().isRequired,
  index: PropTypes.number.isRequired,
};

RideTooltipLeftArrowFooterComponent.displayName =
  'RideTooltipLeftArrowFooterComponent';

export default RideTooltipLeftArrowFooterComponent;
